export default __webpack_public_path__ + "static/media/screenhacker_02.b1b50d1a.png";